import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <ol>
              <p>
                <li>
                  <strong>Study Area</strong>
                </li>
              </p>
            </ol>
            <p>
              Chikamagaluru district (total area 7101 sq. km) is located at
              12&deg; 54&rsquo; 42&rdquo; N,&nbsp; 75&deg; 04&rsquo; 46&rdquo; E
              and 13&deg; 53&prime; 53&rdquo; N, 76&deg; 21&prime; 50&rdquo; E
              in the south-western part of Karnataka (Fig 1). The district is
              divided into seven taluks: Chikamagaluru, Kadur, Koppa, Mudigere,
              Narashimharajapura, Sringeri, and Tarikere. A large western part
              of this district is the 'Malnad' area, an undulating forested
              hilly area. The remaining area, or the eastern part of the
              district is &lsquo;Maidan&rsquo;, which denotes the plain region.
              The district's highest peak is Mullanagiri, which is 1926 meters
              above MSL. There are two main rivers in the district named Tunga
              and Bhadra. Rivers like Hemavati, Netravati, and Vedavathi keep
              flowing throughout the year. The overall climate is cooler because
              of the extensive hilly area. the mean daily maximum temperature
              &nbsp;in April (hottest month) is 36 &deg;C and the mean daily
              minimum temperature is 19 &deg;C. The average rainfall in
              Chikamagaluru district varies from 595 mm to 2379 mm from year to
              year. There are three agro-climatic zones in the Chikamagaluru
              district: the hilly zone (Chikamagaluru, Koppa, Mudigere,
              Narashimharajpura, and Sringeri taluks), central dry zone (Kadur
              taluk) and southern transition zone (Tarikere taluk). Major crops
              which are produced in this region are ragi (55.5%), paddy (45.6),
              sunflower (16.1%), jowar (9.8%), Bengal gram (7.0%), groundnut
              (5.2%) and maize (2.3%). About 5727 ha of the district has
              canal-based irrigation facilities. Arecanut, coconut, coffee,
              black pepper and cardamom agroforestry can be seen in the
              surrounding hills. Coffee was first grown on the slopes of Baba
              Budan Giri hills in Chikamagaluru district in India. In 1966-77,
              around 67000 hectares of area was under coffee plantation,
              producing 40000 tonnes of coffee. About 85,465 ha of the district
              is under coffee plantations, and the average production is about
              55000 million tonnes. According to the 2011 Census data, the total
              population is 11,37,867, with a population density of 158 per sq
              km. Majority (81%) live in the rural areas and 19% in the urban
              (Census, 2011). The district is driven by a thriving agricultural
              economy, and supplemented by incomes from tourism. The GDP of the
              district was 5222 cr. Rs. in 2012-13. The per capita annual income
              of the district was 66366 Rs (2012-13) (District Disaster
              Management Plan, 2019-20; State Gazetteer Advisory Committee 1983;
              NIC 2023).
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/cs1.png" alt="" />
            </p>
            <p>
              Forests in Chikamagaluru district are governed through five
              divisions &ndash; Chikamagaluru (25% forest cover), Bhadra
              Wildlife Sanctuary, &nbsp;Kudremukh National Park, Koppa, and
              Bhadravathi. The vegetation broadly falls into 4 types - dry
              deciduous hill type, moist deciduous type, the evergreen type, and
              the Sholas and Grassland type. Bhadra Wildlife Sanctuary (492.46
              sq km) is situated in the Western Ghats in Chikamagaluru district,
              which has primarily moist deciduous forests in the southern parts
              and dry deciduous forests in the north. The Kudremukh National
              Park is located at the tri-junction of Dakshin Kannada, Udupi, and
              Chikamagaluru districts, which is one of the largest grassland
              shola-based ecosystems in the mid-Western Ghats of Karnataka.
            </p>
            <ol>
              <p>
                <li>
                  <strong>Method</strong>
                </li>
              </p>
            </ol>
            <p>
              The method adopted for this study has been explained in Fig. 2,
              which consists of three sections: (a) assessment of land use
              dynamics, (b) evaluation of fragmentation of forest ecosystem, (c)
              quantification of carbon, and (d) assessment of climate
              variability with agents as decline in forest cover with land use
              changes.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/cs2.png" alt="" />
            </p>

            <p>
              Landscape dynamics:&nbsp; Changes in land uses of Chikamagaluru
              district have been quantified using remote sensing data from 1973
              to 2021 through a Machine Learning (ML) algorithm. Remote sensing
              data (Landsat MSS, TM, ETM+ OLI) have been used from open data
              source USGS (https://earthexplorer.usgs.gov/) for 1973, 1991,
              1998, 2005, 2013 and 2021 analyses using Google Earth Engine
              Platform (https://code.earthengine.google.com/). The remote
              sensing data was pre-processed with geometric and radiometric
              rectifications. Red, Green, and NIR bands of Landsat image were
              used to create False Colour Composite (FCC), which helped identify
              diverse landscape features in the district through heterogeneous
              patches. Training polygons corresponding to heterogeneous patches
              in FCC, evenly distributed covering 10-15% of the study area were
              digitized. Attribute data of training polygons were collected from
              the field through pre-calibrated GPS (global positioning systems)
              and supplemented with information from online portals (Google
              Earth, http://earth.google.com and Bhuwan,
              http://bhuvan.nrsc.gov.in) with high spatial resolution data.
              Temporal spatial data were classified through a supervised,
              non-parametric, machine learning-based Random Forest classifier.
              70% of the training data was used for classification, and 30% was
              used for validation (Lillesand et al., 2014). Random forest
              classifier with a number of decision trees on subsets of the given
              dataset and takes the average value to enhance the predictive
              accuracy. It uses bagging or Bootstrap aggregation, which chooses
              a random sample from the data set. It gives better accuracy than
              other traditional classification methods in a heterogeneous
              landscape.
            </p>
            <p>
              Assessment of fragmentation of forests: The forest fragmentation
              index is calculated with the help of a fixed area window (3x3)
              surrounding a forest pixel. The binary map of forest and
              non-forest categories was generated, excluding waterbody as a
              non-fragmented land cover. Fragmentation of forests is calculated
              through metrics P<sub>f</sub> and P<sub>ff</sub> (Ritters et al.
              2000, p. 4). P<sub>f </sub>determines the proportion of forest
              pixels in the window (equation 1) and P<sub>ff</sub> determines
              the proportion of all cardinal pixel pairs with at least one
              forest pixel, for which both pixels are forested (equation 2).
              Different levels of forest fragmentation are computed through P
              <sub>f</sub> and P<sub>ff</sub> &nbsp;as in table 1.
            </p>
            <p>&nbsp;</p>
            <ol>
              <li>
                <p>
                  Table 1. Detailed account of Fragmentation matrices calculated
                  through P<sub>f</sub> and P<sub>ff </sub>using pair-wise
                  analysis
                </p>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>
                          <strong>Fragmentation classes</strong>
                        </p>
                      </td>
                      <td style={styles.cell} colspan="2" width="81%">
                        <p>
                          <strong>Description</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>Interior</p>
                      </td>
                      <td style={styles.cell} width="51%">
                        <p>
                          Integration of forest pixels and presence of no
                          non-forest pixels.
                        </p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>
                          P<sub>f</sub> = 1
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>Perforated</p>
                      </td>
                      <td style={styles.cell} width="51%">
                        <p>
                          Boundary area between interior forest and patch forest
                          with small perforations.
                        </p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>
                          P<sub>f</sub> &gt; 0.6 and (P<sub>f</sub> &ndash; P
                          <sub>ff</sub>) &lt; 0
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>Edge</p>
                      </td>
                      <td style={styles.cell} width="51%">
                        <p>Boundary of interior forest.</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>
                          P<sub>f</sub> &gt; 0.6 and (P<sub>f</sub> &ndash; P
                          <sub>ff</sub>) &gt; 0
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>Transitional</p>
                      </td>
                      <td style={styles.cell} width="51%">
                        <p>
                          Transition area between forested and non-forested
                          pixels.
                        </p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>
                          0.4 &lt; P<sub>f</sub> &lt; 0.6
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>Patch</p>
                      </td>
                      <td style={styles.cell} width="51%">
                        <p>
                          Small forest pixel patches surrounded by non-forest
                          pixels.
                        </p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>
                          P<sub>f</sub> &lt; 0.4
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>Non-forest</p>
                      </td>
                      <td style={styles.cell} width="51%">
                        <p>
                          Non-forest pixels containing anthropogenic land use
                          areas.
                        </p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>-</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="18%">
                        <p>Waterbody</p>
                      </td>
                      <td style={styles.cell} width="51%">
                        <p>
                          Areas covered with water are considered non-fragmented
                          land use feature.
                        </p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>-</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>&nbsp;</p>
              </li>
            </ol>
            <p>
              Carbon Assessment: Quantification of Carbon in forest ecosystems
              of Chikamagaluru was done based on field data (of AGB, BGB, and
              Soil carbon) and information from published literature. Different
              forest categories computed through remote sensing data were
              validated with the vegetation map developed by the French
              Institute, Pondicherry (Pascal et al. 1986)
            </p>
            <p>
              Carbon stored in vegetation and soil were estimated through
              transect-based quadrats. The number of quadrats per transect in
              the sampled locality ranged between three to five depending on
              saturation of the occurrence of species (species-area curve). Soil
              organic carbon (SOC) is estimated by collecting soil samples (top
              30 cm) across different forest types (Ramachandra and Bharath
              2020, p. 59; Swamy 1992, p. 1) and supplemented with the average
              soil carbon values reported in published literature (Ramachandra
              and Bharath 2020, p. 59; Ravindranath et al. 1997, p. 316;
              Ravindranath and Ostwald 2008, p. 9).
            </p>
            <p>
              Climate Variability Assessment: Daily temperature and
              precipitation data (of 0.5 degree resolution) from 1901 to 2018
              were collected from Indian Meteorological Department (IMD 2018),
              &nbsp;NCAR climate data guide (NCAR 2019), the Princeton
              University Database (Princeton data&mdash;THRG 2019), and
              supplemented with the local climate data (Karnataka State Natural
              Resource Disaster Monitoring Centre (KSNDMC 2018). NCAR data and
              Princeton data at latitude levels were validated through surface
              measurements of IMD and local climate (KSNDMC) data. The mean and
              variance were computed for variability and trend, comparable (with
              deviation &plusmn; 4.3%) to surface measurements (Ramachandra and
              Bharath 2019, p. 2760).
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
